"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_CLOUDSPIRE = createSystem(
  defaultConfig,
  SYSTEM_COMMON,
  {
    theme: {
      tokens: {
        colors: {
          primary: {
            50: { value: "#FAFAFA" },
            100: { value: "#F4F4F5" },
            200: { value: "#E4E4E7" },
            300: { value: "#D4D4D8" },
            400: { value: "#A1A1AA" },
            500: { value: "#71717A" },
            600: { value: "#52525B" },
            700: { value: "#3F3F46" },
            800: { value: "#27272A" },
            900: { value: "#18181B" },
          },
          secondary: {
            50: { value: "#EFF6FF" },
            100: { value: "#DBEAFE" },
            200: { value: "#BFDBFE" },
            300: { value: "#A3CFFF" },
            400: { value: "#60A5FA" },
            500: { value: "#3B82F6" },
            600: { value: "#2563EB" },
            700: { value: "#173DA6" },
            800: { value: "#1A3478" },
            900: { value: "#14204A" },
          },
        },
      },
    },
  },
);
